export default "__VITE_ASSET__T2znjNCa__"